module.exports = __webpack_public_path__ + "img/mrmo.5fbdc43b.jpg";